/* eslint-disable react/require-default-props */
import { getClipboardIcon } from '@/util';
import React from 'react';
import { Input, InputProps } from 'semantic-ui-react';

interface FormInputProps extends InputProps {
  name?: string;
  value: string | undefined;
  copyable?: boolean;
}

export const FormTextInput = ({
  id,
  name,
  value,
  copyable = false,
  readOnly,
  ...props
}: FormInputProps) => {
  return (
    <Input
      value={value}
      icon={copyable ? getClipboardIcon(value ?? '', name ?? id) : undefined}
      readOnly={!!copyable || readOnly}
      {...props}
    />
  );
};
